import { any, get, compose, isEqual } from 'lodash/fp';
import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { formValuesSelector } from '@mews-commander/legacy-form';
import { getServiceOption } from '@mews-commander/legacy-entities/src/ducks/services';
import { getReservationsServices } from '../../../selectors';
import { ReceiverSelectValues } from '../../../enums';
import { ConfirmationFormValues } from './types';

const confirmationFormValuesSelector = formValuesSelector<ConfirmationFormValues>;

export const isCustomEmailSelected = compose(
    isEqual(ReceiverSelectValues.CustomEmail),
    get('confirmationEmailType'),
    confirmationFormValuesSelector
);
export const isSendConfirmationEmailChecked = flow(
    confirmationFormValuesSelector,
    (formValues) => formValues?.sendConfirmationEmail
);

export const getInitialValues = createSelector(getReservationsServices, (services) => ({
    sendConfirmationEmail: any(getServiceOption('sendConfirmationEmailByDefault'))(services),
    confirmationEmailType: ReceiverSelectValues.CustomerEmail,
}));
